import { keymap } from 'prosemirror-keymap';

import { toggleStrong } from '../commands';

const boldKeymap = keymap({
	'Mod-b': toggleStrong,
});

export default boldKeymap;
